import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ReservationPluginInfo } from 'projects/qcloud-models/reservation-plugin/reservation-plugin-info';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationPluginService } from '../../services/reservation-plugin.service';
import { TicketReservationService } from '../../services/ticket-reservation.service';

@Component({
  selector: 'app-reservation-form',
  templateUrl: './reservation-form.component.html',
  styleUrls: ['./reservation-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReservationFormComponent implements OnInit {

  ticketReservation = new TicketReservationPlugin();
  reservationToSend: TicketReservationPlugin;
  reservationInfo: ReservationPluginInfo;
  formInvalid: boolean;
  termsChecked: boolean;
  showTerms = false;
  confirm = false;
  selectedCategoryName = "";

  constructor(private ticketReservationService: TicketReservationService, public service: ReservationPluginService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
    });
  }

  ngOnInit(): void {
    this.service.getReservationData().subscribe(
      data => {
        this.reservationInfo = data;
        this.service.setRecaptchaKey(data.configuration.recaptchaPublicKey);
      }
    );
  }

  confirmReservation(event: TicketReservationPlugin) {
    this.confirm = true;
    this.reservationToSend = event;
  }

  undoConfirmReservation(event: boolean) {
    this.confirm = event;
  }

  checkForm(event: boolean) {
    this.formInvalid = event;
  }

}
